"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeout = exports.getIdentifier = void 0;
var _fastJsonStableStringify = _interopRequireDefault(require("fast-json-stable-stringify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * Implementation of the timeout.
 * Based on: https://github.com/github/fetch/issues/175#issuecomment-125779262
 */
var timeout = exports.timeout = function timeout(ms, promise, controller) {
  return new Promise(function (resolve, reject) {
    var timeoutId = setTimeout(function () {
      controller === null || controller === void 0 ? void 0 : controller.abort();
      reject(new Error('timeout'));
    }, ms);
    promise.then(function (res) {
      clearTimeout(timeoutId);
      resolve(res);
    }).catch(function (error) {
      clearTimeout(timeoutId);
      reject(error);
    });
  });
};

/**
 * Generates a unique identifier from a request, using the request data like
 * URL, body, headers... from an HTTP request.
 */
var getIdentifier = exports.getIdentifier = function getIdentifier(link, variables, options) {
  var uid = link;
  if (variables) {
    uid += (0, _fastJsonStableStringify.default)(variables);
  }
  if (_typeof(options) === 'object') {
    var serializedOptions = _objectSpread({}, options);
    var keys = Object.keys(options);
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var value = options[key];
      if (value instanceof URLSearchParams) {
        serializedOptions[key] = value.toString();
      }
    }
    uid += (0, _fastJsonStableStringify.default)(serializedOptions);
  }
  return uid;
};